"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQuery = parseQuery;
exports.archiveFile = archiveFile;
exports.unarchiveFile = unarchiveFile;
exports.fetchFiles = fetchFiles;
exports.fetchSingleFile = fetchSingleFile;
exports.fetchIntegratedVideos = fetchIntegratedVideos;
exports.move = move;
exports.uploadResizedImage = uploadResizedImage;
exports.recalculateImageDimensions = recalculateImageDimensions;
exports.saveThumbnail = saveThumbnail;
exports.generateAndUpdateThumbnail = generateAndUpdateThumbnail;
exports.exportFiles = exportFiles;
exports.downloadFromUrl = downloadFromUrl;
exports.remove = remove;
exports.getDownloadUrl = getDownloadUrl;
exports.removeCanvaId = removeCanvaId;
exports.setCanvaId = setCanvaId;
exports.updateFileMeta = updateFileMeta;
exports.getSignedUrl = getSignedUrl;
exports.getDownloadableSignedUrl = getDownloadableSignedUrl;
exports.getSignedUrlRedirectViewUrl = getSignedUrlRedirectViewUrl;
exports.getSignedUrlRedirectDownloadUrl = getSignedUrlRedirectDownloadUrl;
exports.replaceFile = exports.uploadFile = exports.uploadFileV3 = exports.buildFileFromAttrs = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _immutable = require("immutable");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _getApiUrl = _interopRequireDefault(require("../utils/getApiUrl"));

var _Constants = require("../Constants");

var _InternalFileManagerFileAccess = require("../enums/InternalFileManagerFileAccess");

var BASE_URI = 'filemanager/api/v2/files';
var BASE_V3_URI = 'filemanager/api/v3/files';
var DEFAULT_QUERY = {
  archived: 0,
  is_cta_image: 0,
  order_by: '-updated'
};
var QUERY_PARAM_OPTIONS = ['folder_path', 'folder_id', 'offset', 'limit', 'type', 'archived', 'order_by', 'provider', 'hostApp'];
var ATTACHMENT_QUERY_PARAM = {
  'response-content-disposition': 'attachment'
};

function parseQuery(options) {
  var query = {};

  if (options.get('search')) {
    query.name__icontains = options.get('search');
  }

  if (options.get('archived')) {
    query.archived = options.get('archived') ? 1 : 0;
  }

  var filtered = options.filter(function (val, key) {
    return QUERY_PARAM_OPTIONS.includes(key) && typeof val !== 'undefined';
  });
  return Object.assign({}, DEFAULT_QUERY, {}, filtered.toJS(), {}, query);
}

var buildFileFromAttrs = function buildFileFromAttrs(attrs) {
  attrs.category = _Constants.ObjectCategory.FILE;
  return (0, _immutable.fromJS)(attrs);
};

exports.buildFileFromAttrs = buildFileFromAttrs;

var buildFilesPayload = function buildFilesPayload(resp) {
  return (0, _immutable.Map)(Object.assign({}, resp, {
    objects: (0, _immutable.List)(resp.objects.map(buildFileFromAttrs))
  }));
};

function archiveFile(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var URI = BASE_URI + "/" + fileId + "/archive";
  return httpClient.post(URI, {
    data: {
      archived: true
    }
  }).then(buildFileFromAttrs);
}

function unarchiveFile(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var URI = BASE_URI + "/" + fileId + "/archive";
  return httpClient.post(URI, {
    data: {
      archived: false
    }
  }).then(buildFileFromAttrs);
}

function fetchFiles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var promise = httpClient.get(BASE_URI, {
    query: parseQuery(options),
    timeout: 30000
  });
  return promise.then(buildFilesPayload);
}

function fetchSingleFile(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.get(BASE_V3_URI + "/" + fileId).then(buildFileFromAttrs);
}

function fetchIntegratedVideos() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.get(BASE_URI + "/integrated-videos", {
    query: parseQuery(options),
    timeout: 15000
  }).then(buildFilesPayload);
}

function move(fileId, options) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var URI = BASE_URI + "/" + fileId + "/move-file";
  return httpClient.post(URI, {
    data: options
  }).then(buildFileFromAttrs);
}

var sanitizeFileName = function sanitizeFileName(fileName) {
  return fileName.replace(/\./gm, '-');
};

var COMMON_FILE_UPLOAD_PARAMS = {
  timeout: 0,
  headers: {
    'content-type': false
  }
};

var uploadFileV3 = function uploadFileV3(file, uploadedFileAccess) {
  var fileUploadOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      updateProgress = _ref.updateProgress,
      xhrCallback = _ref.xhrCallback,
      _ref$httpClient = _ref.httpClient,
      httpClient = _ref$httpClient === void 0 ? _apiClient.default : _ref$httpClient;

  if (!file) {
    throw new Error('`file` arg is required and must be a local File');
  }

  if (!Object.keys(_InternalFileManagerFileAccess.FileAccessValues).includes(uploadedFileAccess)) {
    throw new Error('[FileManagerCore/uploadFile(V3)] Missing or invalid uploadedFileAccess param. Visit https://product.hubteam.com/docs/file-manager-manual/Frontend/index.html for details.');
  }

  var folderId = fileUploadOptions.folderId,
      folderPath = fileUploadOptions.folderPath,
      fileName = fileUploadOptions.fileName,
      extraOptions = (0, _objectWithoutProperties2.default)(fileUploadOptions, ["folderId", "folderPath", "fileName"]);
  extraOptions.access = uploadedFileAccess;
  var formData = new FormData();
  formData.append('file', file);

  if (folderId) {
    formData.append('folderId', folderId);
  }

  if (folderPath) {
    formData.append('folderPath', folderPath);
  }

  if (fileName) {
    formData.append('fileName', sanitizeFileName(fileName));
  }

  formData.append('options', JSON.stringify(extraOptions));
  return httpClient.post(BASE_V3_URI + "/upload", Object.assign({}, COMMON_FILE_UPLOAD_PARAMS, {
    data: formData,
    withXhr: function withXhr(xhr) {
      xhr.upload.addEventListener('progress', updateProgress, false);

      if (xhrCallback) {
        xhrCallback(xhr);
      }
    }
  })).then(buildFilesPayload);
};

exports.uploadFileV3 = uploadFileV3;
var uploadFile = uploadFileV3;
exports.uploadFile = uploadFile;

var replaceFile = function replaceFile(fileId, file, uploadedFileAccess) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      updateProgress = _ref2.updateProgress;

  var formData = new FormData();
  formData.append('file', file);
  formData.append('options', JSON.stringify({
    access: uploadedFileAccess
  }));
  return _apiClient.default.post(BASE_V3_URI + "/" + fileId + "/replace", Object.assign({}, COMMON_FILE_UPLOAD_PARAMS, {
    data: formData,
    withXhr: function withXhr(xhr) {
      xhr.upload.addEventListener('progress', updateProgress, false);
    }
  })).then(buildFilesPayload);
};

exports.replaceFile = replaceFile;

function uploadResizedImage(fileId, newWidth) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.post(BASE_URI + "/" + fileId + "/resize-image", {
    timeout: 0,
    query: {
      width: newWidth
    }
  }).then(buildFileFromAttrs);
}

function recalculateImageDimensions(fileId) {
  return _apiClient.default.post(BASE_V3_URI + "/" + fileId + "/recalculate-image-dimensions", {
    timeout: 5000
  }).then(buildFileFromAttrs);
}

function saveThumbnail(sourceFileId, targetFileId) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.post(BASE_V3_URI + "/" + targetFileId + "/thumbnails/replace", {
    data: {
      sourceFileId: sourceFileId
    }
  }).then(buildFileFromAttrs);
}

function generateAndUpdateThumbnail(targetFileId, thumbnailTimestamp) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.post(BASE_V3_URI + "/" + targetFileId + "/thumbnails/generate?", {
    timeout: 35000,
    data: {
      thumbnailTimestamp: thumbnailTimestamp
    }
  }).then(buildFileFromAttrs);
}

function exportFiles(emailAddress) {
  var filesAndFolders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var uri = BASE_URI + "/export-all-files";
  return httpClient.post(uri, {
    data: Object.assign({
      email_address: emailAddress
    }, filesAndFolders)
  }).then(_immutable.fromJS);
}

function downloadFromUrl() {
  var fileDownloadOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 ? arguments[1] : undefined;
  var uploadedFileAccess = arguments.length > 2 ? arguments[2] : undefined;
  var httpClient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _apiClient.default;

  if (!Object.keys(_InternalFileManagerFileAccess.FileAccessValues).includes(uploadedFileAccess)) {
    throw new Error('[FileManagerCore/downloadFromUrl] Missing or invalid uploadedFileAccess param. Visit https://product.hubteam.com/docs/file-manager-manual/Frontend/index.html for details.');
  }

  return httpClient.post(BASE_V3_URI + "/synchronous-download-from-url", {
    timeout: 60000,
    data: Object.assign({}, fileDownloadOptions, {
      access: uploadedFileAccess,
      url: url
    })
  }).then(buildFileFromAttrs);
}

function remove(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.delete(BASE_URI + "/" + fileId);
}

function getDownloadUrl(path, version) {
  return (0, _getApiUrl.default)(BASE_URI + "/download/" + path, {
    version: version
  });
}

function removeCanvaId(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.delete(BASE_V3_URI + "/" + fileId + "/canva").then(buildFileFromAttrs);
}

function setCanvaId(fileId, canvaId) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.put(BASE_V3_URI + "/" + fileId + "/canva", {
    data: {
      canvaId: canvaId
    }
  }).then(buildFileFromAttrs);
}

function updateFileMeta(fileId, data, httpClient) {
  return httpClient.patch(BASE_V3_URI + "/" + fileId + "/meta", {
    data: data
  }).then(buildFileFromAttrs);
}

function getSignedUrl(fileId) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.get(BASE_URI + "/" + fileId + "/signed-url", {
    query: query
  });
}

function getDownloadableSignedUrl(fileId, httpClient) {
  return getSignedUrl(fileId, ATTACHMENT_QUERY_PARAM, httpClient);
}

function getSignedUrlRedirectViewUrl(fileId) {
  return (0, _getApiUrl.default)(BASE_URI + "/" + fileId + "/signed-url-redirect");
}

function getSignedUrlRedirectDownloadUrl(fileId) {
  return (0, _getApiUrl.default)(BASE_URI + "/" + fileId + "/signed-url-redirect", ATTACHMENT_QUERY_PARAM);
}